// removed by extract-text-webpack-plugin
module.exports = {"address":"address___fI92y"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AuctioneerInfo/AuctioneerAddress.scss
// module id = 9iAi
// module chunks = 46